import React, { forwardRef } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils.js";

/* ---------------- PriorityFlag ---------------- */

export type Priority = "P1" | "P2" | "P3" | "P4";

export const priorityFlagVariants = cva(
  "inline-flex items-center justify-center rounded border px-1.5 py-0.5 text-dense-2 font-semibold tracking-wider pb-tabular",
  {
    variants: {
      level: {
        P1: "border-pb-red/50 text-pb-red-text bg-pb-red-soft",
        P2: "border-pb-amber/50 text-pb-amber-text bg-pb-amber-soft",
        P3: "border-pb-cyan/50 text-pb-cyan-text bg-pb-cyan-soft",
        P4: "border-pb-border text-pb-text-muted bg-pb-card-elevated",
      },
    },
  },
);

export interface PriorityFlagProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    Required<Pick<VariantProps<typeof priorityFlagVariants>, "level">> {}

export const PriorityFlag = forwardRef<HTMLSpanElement, PriorityFlagProps>(
  function PriorityFlag({ level, className, ...rest }, ref) {
    return (
      <span
        ref={ref}
        className={cn(priorityFlagVariants({ level }), className)}
        {...rest}
      >
        {level}
      </span>
    );
  },
);
